module.exports = __webpack_public_path__ + "static/media/inna.2001268b.JPG";